<h1 mat-dialog-title>Éditer {{ data.product.name }}</h1>
<div mat-dialog-content>
  <app-edit-product-form
    [product]="data.product"
    (updatedProduct)="submitUpdatedProduct($event)"
  ></app-edit-product-form>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Annuler</button>
</div>
